import Image from "next/image";
import healthyImage from "@/public/img/about/healthy.jpg";
import { m } from "framer-motion";
import { useTranslation } from "next-i18next";

const VisionSection = () => {
  const { i18n } = useTranslation();
  const rtl = i18n.dir() === "rtl";

  return (
    <section className="relative flex bg-gradient-to-r from-lime-50/80 to-lime-50/80 dark-theme:from-black/80 dark-theme:to-green-950/80 md:to-lime-50/60 dark-theme:md:to-green-950/60 lg:to-lime-50/20 dark-theme:lg:to-green-950/20">
      <Image
        src={healthyImage}
        alt=""
        fill
        className="absolute inset-0 -z-10 h-full w-full origin-center object-cover object-center ltr:-scale-x-100"
        sizes="(max-width: 600px) 600px, (max-width: 900px) 900px, (max-width: 1200px) 1200px, (max-width: 1500px) 1500px, 2000px"
      />
      <div className="container flex flex-col items-start justify-center gap-2 px-4 py-16">
        <div className="flex h-[312px] max-w-[584px] flex-col items-start justify-center gap-6 sm:h-[450px] md:h-[591px]">
          <m.div
            className="flex flex-col items-start justify-center gap-6"
            initial={{ opacity: 0, x: rtl ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <h2
              id="vision"
              className="self-stretch p-0 text-3xl font-bold leading-9 text-primary-700"
            >
              Shaping a Sustainable Future
            </h2>
            <div className="self-stretch text-base font-medium leading-normal text-auto-black/65">
              As a global leader in frozen vegetables, AlHayat Foodstuff
              envisions a future where sustainability drives the food industry.
              We aspire to be the trusted partner for businesses worldwide,
              recognized for reliability and product excellence. Integrating
              responsibility into every aspect, from farm to market, we aim to
              enrich lives and empower communities through high-quality frozen
              vegetables.
            </div>
          </m.div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
